import { render, staticRenderFns } from "./purchase_request.vue?vue&type=template&id=3569ffd6&scoped=true&"
import script from "./purchase_request.vue?vue&type=script&lang=js&"
export * from "./purchase_request.vue?vue&type=script&lang=js&"
import style0 from "./purchase_request.vue?vue&type=style&index=0&id=3569ffd6&prod&lang=css&"
import style1 from "./purchase_request.vue?vue&type=style&index=1&id=3569ffd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3569ffd6",
  null
  
)

export default component.exports